import {routingPreferences} from './Constants';
import {apiCall} from './MapUtils';

let movedIcon = null;
export function addMouseevents(map, features, routeFeature) {
	var canvas = map.getCanvasContainer();
	function onMove(e) {
		var coords = e.lngLat;

		// Set a UI indicator for dragging.
		canvas.style.cursor = 'grabbing';

		// Update the Point feature in `geojson` coordinates
		// and call setData to the source layer `point` on it.
		if (movedIcon == 'start') {
			features[0] = {
				type: 'Feature',
				geometry: {
					type: 'Point',
					coordinates: [coords.lng, coords.lat],
				},
				properties: {id: 'start'},
			};
		} else {
			features[1] = {
				type: 'Feature',
				geometry: {
					type: 'Point',
					coordinates: [coords.lng, coords.lat],
				},
				properties: {id: 'stop'},
			};
		}
		routeFeature = {
			type: 'Feature',
			properties: {},
			geometry: {
				type: 'LineString',
				coordinates: [features[0].geometry.coordinates, features[1].geometry.coordinates],
			},
		};
		map.getSource('routePoint').setData({
			type: 'FeatureCollection',
			features: features,
		});
		map.getSource('route').setData(routeFeature);
		map.getSource('wheelchairRoute').setData({
			type: 'Feature',
			properties: {},
			geometry: {
				type: 'LineString',
				coordinates: [],
			},
		});
		map.getSource('walkRoute').setData({
			type: 'Feature',
			properties: {},
			geometry: {
				type: 'LineString',
				coordinates: [],
			},
		});
	}

	function getRoute(preferences, layer, features) {
		const request = {
			heading: 0,
			preferences: preferences,
			start: {
				lat: features[0].geometry.coordinates[1],
				lon: features[0].geometry.coordinates[0],
			},
			target: {
				lat: features[1].geometry.coordinates[1],
				lon: features[1].geometry.coordinates[0],
			},
			types: ['NORMAL'],
		};
		const options = {
			service: 'routing/plan',
			request: JSON.stringify(request),
			lang: 'en',
		};

		apiCall(options)
			.then((data) => {
				console.log(data);
				if (data.code == 'Ok') {
					let feature = {
						type: 'Feature',
						geometry: {type: 'LineString', coordinates: []},
					};
					data.routes.forEach((route) => {
						route.legs.forEach((leg) => {
							leg.steps.forEach((step) => {
								step.geometry.coordinates.forEach((coordinate) => {
									feature.geometry.coordinates.push([coordinate.lon, coordinate.lat]);
								});
							});
						});
					});
					map.getSource(layer).setData(feature);
				}
			})
			.catch((err) => console.log(err));
	}

	function onUp(e) {
		var coords = e.lngLat;
		console.log('[' + coords.lng.toFixed(5) + ',' + coords.lat.toFixed(5) + ']');
		getRoute(routingPreferences.walk, 'walkRoute', features);
		getRoute(routingPreferences.wheelchair, 'wheelchairRoute', features);

		// Print the coordinates of where the point had
		// finished being dragged to on the map.
		//coordinates.style.display = 'block';
		//coordinates.innerHTML = 'Longitude: ' + coords.lng + '<br />Latitude: ' + coords.lat;
		canvas.style.cursor = '';

		// Unbind mouse/touch events
		map.off('mousemove', onMove);
		map.off('touchmove', onMove);
	}
	// When the cursor enters a feature in the point layer, prepare for dragging.
	map.on('mouseenter', 'point', function (e) {
		// map.setPaintProperty('point', 'circle-color', '#3bb2d0');
		movedIcon = e.features[0].properties.id;
		canvas.style.cursor = 'move';
		console.log(movedIcon);
	});

	map.on('mouseleave', 'point', function () {
		//map.setPaintProperty('point', 'circle-color', '#3887be');
		canvas.style.cursor = '';
	});

	map.on('mousedown', 'point', function (e) {
		// Prevent the default map drag behavior.
		e.preventDefault();

		canvas.style.cursor = 'grab';

		map.on('mousemove', onMove);
		map.once('mouseup', onUp);
	});

	map.on('touchstart', 'point', function (e) {
		console.log(e);
		if (e.points.length !== 1) return;
		// Prevent the default map drag behavior.
		e.preventDefault();

		map.on('touchmove', onMove);
		map.once('touchend', onUp);
	});

	getRoute(routingPreferences.walk, 'walkRoute', features, routeFeature, map);
	getRoute(routingPreferences.wheelchair, 'wheelchairRoute', features, routeFeature, map);
}
